import React from 'react';
import { useTable } from 'react-table';

require('./managepermtable.css');

const GeneralTable = (props) => {
    const { column, data } = props;
    return (
        <div className="col-auto overflow-auto fixed-table-container">
            <div className="table-container prl-10">
                <Table
                    columns={column}
                    data={data}
                    // isFilterable={props.isFilterable}
                    // isSortable={props.isSortable}
                />
            </div>
        </div>
    );
};

const Table = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
        {
            columns,
            data,
            autoResetFilters: false,
        }
        // useFilters,
        // useSortBy
    );

    return (
        <>
            <table {...getTableProps()} className="table table-striped indRoleTbl">
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()} rowSpan={column.row}>
                                    {column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                                })}
                            </tr>
                        );
                    })}
                </tbody>
                {/* <thead>
          <tr>
            {headers.map((column, id) => (
              <th
                // {...column.getHeaderProps(column.getSortByToggleProps())}
                key={id}
                className={`${column.render('id')}`}
              >
                <div className='th-table col-12 p-0'>
                  {column.render('Header')}
                </div>
              </th>
            ))}
          </tr>
        </thead> */}
                {/* <tbody>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr
                {...row.getRowProps()}
                style={{
                  backgroundColor: row.original.color,
                  borderColor: row.original.color
                }}
              >
                {row.cells.map(cell => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className={`${cell.column.id}`}
                    >
                      {cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody> */}
            </table>
        </>
    );
};

export default React.memo(GeneralTable);
